import React, { useEffect, useState } from "react";
import TextArea from "antd/lib/input/TextArea";
import { merge } from "lodash";

const DescriptionBox = ({ currentBody, update }) => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (currentBody?.fields?.description?.content?.[0]?.content?.[0]?.text) {
      setDescription(currentBody.fields.description.content[0].content[0].text);
    }
  }, [currentBody]);

  const onChangeDescription = (e) => {
    const descriptionTemplate = {
      type: "doc",
      version: 1,
      content: [
        {
          type: "paragraph",
          content: [
            {
              text: e.target.value,
              type: "text",
            },
          ],
        },
      ],
    };

    const descriptionBody = { fields: { description: descriptionTemplate } };
    const updatedBody = merge({}, currentBody, descriptionBody);
    setDescription(e.target.value);
    update(updatedBody);
  };

  return (
    <>
      <label>Description</label>
      <TextArea
        onChange={onChangeDescription}
        name="description"
        value={description}
        className="ihub-comment-box"
        rows={10}
      />
    </>
  );
};

export default DescriptionBox;
